export default __webpack_public_path__ + "static/media/micOn.4b79c904.svg";